const ActionType = {
  GET_PARAMETERS_OPTIONS: 'calculations/get-parameters-options',
  CALCULATE: 'calculations/calculate',
  RESET_CALCULATIONS: 'calculations/reset-calculations',
  GET_PDF_FILE: 'calculations/get-pdf-file',
}

export default ActionType
